import { Button } from "@/components/ui/button";
import { Link } from "wouter";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

const features = [
  {
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
      </svg>
    ),
    iconBg: "bg-primary",
    title: "PEP-Aligned Question Bank",
    description:
      "Thousands of practice questions mapped to the Jamaican PEP curriculum across all four subjects: Maths, English, Science and Social Studies. Questions range from basic recall to higher-order thinking, mirroring the actual PEP exam format.",
  },
  {
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    iconBg: "bg-primary",
    title: "Gamified Learning",
    description:
      "Students earn XP points, level up, maintain daily streaks and unlock achievements as they study. The game-like experience keeps children engaged and coming back every day.",
  },
  {
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
      </svg>
    ),
    iconBg: "bg-primary",
    title: "AI-Powered Recommendations",
    description:
      "The platform analyses each student's performance in real time and serves up questions that target their weak areas. Students always practise what they need most.",
  },
  {
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
      </svg>
    ),
    iconBg: "bg-primary",
    title: "Detailed Progress Reports",
    description:
      "Parents and students get clear, visual breakdowns of performance by subject and topic. See exactly where your child is strong and where they need more focus.",
  },
  {
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
      </svg>
    ),
    iconBg: "bg-[#25D366]",
    title: "Weekly WhatsApp Reports for Parents",
    description:
      "Every week, parents receive a personalised progress summary directly on WhatsApp. No need to log in. The update comes to you. Available on the Annual plan.",
  },
  {
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" />
      </svg>
    ),
    iconBg: "bg-[#b88a00]",
    title: "Academy Leaderboard and Prizes",
    description:
      "Students compete on the Academy Leaderboard for a chance to win GiftMe smart cards each month. Top 5 students win. The competition motivates students to study consistently.",
  },
  {
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
      </svg>
    ),
    iconBg: "bg-primary",
    title: "Reading Materials",
    description:
      "Curated reading passages and comprehension exercises to support English Language preparation. Students build vocabulary, fluency and critical reading skills at their own pace.",
  },
  {
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
      </svg>
    ),
    iconBg: "bg-primary",
    title: "Works on Any Device",
    description:
      "No app download required. EduFocal works on any phone, tablet or computer with a browser. Students can pick up exactly where they left off across devices.",
  },
  {
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
    iconBg: "bg-amber-400",
    // Was "Study Streaks and Daily Goals". There is no daily-goal feature in the product: a grep
    // for dailyGoal across client, server and shared returned only this marketing string. Streaks,
    // badges and levels are all real and shipped, so the claim is now what the student actually gets.
    title: "Streaks, Badges and Levels",
    description:
      "A day counts once a student answers three or more questions, and the streak keeps them coming back. Every correct answer earns XP toward the next level, and badges unlock along the way, with the locked ones showing what to chase next.",
  },
];

function HeroSection() {
  return (
    <section className="relative overflow-hidden bg-primary py-20 md:py-28">
      <div className="absolute inset-0 overflow-hidden">
      </div>

      <div className="container relative px-4 md:px-6 max-w-4xl mx-auto text-center">
        <p className="text-sm font-semibold uppercase tracking-widest text-white/70 mb-4">
          Platform Features
        </p>
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.1] tracking-tight text-white mb-6">
          Everything Your Child Needs to{" "}
          <span className="text-amber-300">Ace PEP</span>
        </h1>
        <p className="text-lg md:text-xl text-white/85 max-w-2xl mx-auto mb-10 leading-relaxed">
          EduFocal Academy is built specifically for Jamaica's PEP curriculum for Grades 4, 5 and 6. Every feature is designed to help your child study smarter, stay motivated and perform their best on exam day.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link href="/signup">
            <Button
              size="lg"
              className="text-lg px-10 py-7 rounded-xl bg-amber-400 text-foreground hover:bg-amber-300 shadow-xl hover:shadow-2xl transition-all min-h-14 font-bold tracking-wide"
            >
              Get Started
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}

function FeaturesGrid() {
  return (
    <section className="py-20 md:py-28 bg-card">
      <div className="container px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-14 md:mb-16">
          <p className="font-semibold text-sm uppercase tracking-wider text-primary mb-3">
            What's Included
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-foreground tracking-tight mb-4">
            A Complete PEP Prep Platform
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Every tool your child needs to build confidence, close gaps and arrive at the PEP exam ready to succeed.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-card border border-border rounded-2xl shadow-sm hover:shadow-md transition-shadow p-7 md:p-8 flex flex-col gap-4"
            >
              <div
                className={`w-12 h-12 ${feature.iconBg} rounded-xl flex items-center justify-center flex-shrink-0 text-white shadow-sm`}
              >
                {feature.icon}
              </div>
              <div>
                <h3 className="text-lg font-bold text-foreground mb-2">
                  {feature.title}
                </h3>
                <p className="font-[Inter] text-muted-foreground text-sm leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function SubjectHighlights() {
  const subjects = [
    { label: "Maths", color: "bg-primary", textColor: "text-primary", bgLight: "bg-primary/8" },
    { label: "English Language", color: "bg-primary", textColor: "text-primary", bgLight: "bg-primary/8" },
    { label: "Science", color: "bg-[#25a560]", textColor: "text-[#25a560]", bgLight: "bg-[#25a560]/8" },
    { label: "Social Studies", color: "bg-[#b88a00]", textColor: "text-[#b88a00]", bgLight: "bg-amber-400/15" },
  ];

  return (
    <section className="py-16 md:py-20 bg-primary/5/50">
      <div className="container px-4 md:px-6 max-w-5xl mx-auto text-center">
        <p className="font-semibold text-sm uppercase tracking-wider text-primary mb-3">
          Curriculum Coverage
        </p>
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-foreground tracking-tight mb-4">
          All Four PEP Subjects, Fully Covered
        </h2>
        <p className="text-lg text-muted-foreground max-w-xl mx-auto mb-10">
          Practice questions, reading materials and progress tracking across every subject your child will be examined in.
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {subjects.map((subject) => (
            <div
              key={subject.label}
              className={`${subject.bgLight} rounded-2xl p-6 md:p-8 flex flex-col items-center gap-3`}
            >
              <div className={`w-3 h-3 ${subject.color} rounded-xl`}></div>
              <span className={`font-bold text-base md:text-lg ${subject.textColor}`}>
                {subject.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function CtaSection() {
  return (
    <section className="py-20 md:py-28 bg-primary relative overflow-hidden">
      <div className="absolute inset-0">
      </div>

      <div className="container relative px-4 md:px-6 max-w-4xl mx-auto text-center">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white tracking-tight mb-6">
          Ready to Get Started?
        </h2>
        <p className="text-lg md:text-xl text-white/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          Give your child access to everything they need to prepare for PEP with confidence. Set up takes less than five minutes.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link href="/signup">
            <Button
              size="lg"
              className="text-lg px-10 py-7 rounded-xl bg-amber-400 text-foreground hover:bg-amber-300 shadow-xl hover:shadow-2xl transition-all min-h-14 font-bold"
            >
              Get Started
            </Button>
          </Link>
          <Button
            size="lg"
            variant="outline"
            className="text-lg px-10 py-7 rounded-xl border-2 border-white/30 text-white hover:bg-card/10 min-h-14 font-semibold bg-transparent"
            onClick={() => window.location.href = '/contact'}
          >
            Text Us
          </Button>
        </div>
        <p className="text-white/50 text-sm mt-6">Cancel anytime. No long-term commitment required.</p>
      </div>
    </section>
  );
}

export default function FeaturesPage() {
  return (
    <div className="min-h-screen bg-card">
      <Header />
      <main>
        <HeroSection />
        <FeaturesGrid />
        <SubjectHighlights />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}
